import React from 'react';
import { StudioPackagePickerModule } from '../modules/studio-package-picker.module';

export const Application = () => {
  return <StudioPackagePickerModule.internals.components.AppRouter />;
};
